var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("hallo")])
}
var staticRenderFns = []

export { render, staticRenderFns }